<div [ngClass]="rowClass">
	<!-- <div class="row"> -->
	<label [for]="formElement.name" [ngClass]="labelClass">
		{{ label || formElement.label }}
		<span
			class="mandatoryColor"
			*ngIf="
				(label || formElement.label) &&
				(required || formElement.required || formElement.showAstrisk)
			"
			>*</span
		>
	</label>
	<div [ngClass]="inputClass || 'col-10'">
		<ng-container *ngIf="formElement.multi">
			<select
				required="true"
				multiple
				[compareWith]="compareFn"
				[disabled]="isDisabled()"
				(blur)="makeDirty()"
				[name]="name || formElement.name"
				[ngClass]="selectClass"
				[id]="name || formElement.name"
				[(ngModel)]="value"
				(change)="onChange(value)"
			>
				<option value="" disabled>{{ placeholder }}</option>
				<option [ngValue]="option.value" *ngFor="let option of options">
					{{ option.Changedname ? option.Changedname : option.name }}
				</option>
			</select>
			<span
				*ngIf="formElement.metainfo"
				[ngClass]="{ infoTextColor: formElement.metaTextcolor }"
				class="m-form__help"
			>
				{{ formElement.metainfo }}
			</span>
		</ng-container>
		<ng-container *ngIf="!formElement.multi">
			<div
				*ngIf="!formElement.disabled && !formElement.readOnly"
				class="form-select-side"
			>
				<svg
					width="10px"
					height="12px"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 129 129"
					enable-background="new 0 0 129 129"
				>
					<g>
						<path
							d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
						></path>
					</g>
				</svg>
			</div>
			<select
				[compareWith]="compareFn"
				required="true"
				[disabled]="isDisabled()"
				(blur)="makeDirty()"
				[name]="name || formElement.name"
				[ngClass]="selectClass"
				[id]="name || formElement.name"
				[(ngModel)]="value"
				(change)="onChange(value)"
			>
				<option value="" disabled>{{ placeholder }}</option>
				<option [ngValue]="option.value" *ngFor="let option of options">
					{{ option.Changedname ? option.Changedname : option.name }}
				</option>
			</select>
			<span
				*ngIf="formElement.metainfo"
				[ngClass]="{ infoTextColor: formElement.metaTextcolor }"
				class="m-form__help"
			>
				{{ formElement.metainfo }}
			</span>
		</ng-container>
		<ng-container *ngIf="!formElement.silentRequired">
			<ng-content></ng-content>
		</ng-container>
	</div>
</div>
